import SearchForm from './SearchForm'
import Router from 'next/router'
import { serviceFormInputsMobile, serviceFormInputs } from '@components/search/serviceFormInputs'
import { SERVICE_LINK_BASE } from '@constants/searchFormLinks'
import searchFormLink from '@utils/links/searchFormLink'

const ServiceForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: SERVICE_LINK_BASE,
            isMakeModelBase: false,
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={serviceFormInputs}
        mobileInputs={serviceFormInputsMobile}
        dataKey="service"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo: null,
            clear: true,
            advancedOptions: null,
        }} />
}

export default ServiceForm